import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from 'Palette';

export const FooterInput = styled(TextField)<{ className?: string }>(({ className }) => ({
  '& input': {
    color: 'rgba(255,255,255,0.8)',
  },
  '& label': {
    color: 'rgba(255,255,255,0.8)',
  },
  className: `react-FooterInput ${className || ''}`.trim(),
}));

export const FooterContainer = styled(Box)<{ className?: string }>(({ theme, className }) => ({
  backgroundColor: Palette.tone4.background,
  color: Palette.tone4.text,
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  className: `react-FooterContainer ${className || ''}`.trim(),
}));

export const FooterLogo = styled('img')<{ className?: string }>(({ className }) => ({
  width: 40,
  marginBottom: 8,
  className: `react-FooterLogo ${className || ''}`.trim(),
}));
